import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import CategoryBanner from "../CategoryBanner/CategoryBanner";

// Main component for AgriInput Marketplcae
const ExploreCareProducts = () => {
  //  Placeholder for category Image
  const categoryImage = {};

  return (
    <>
      {/* Header Component */}
      <HeaderComponent className="noShadow" />
      {/* Component showing all categories and products list */}
      <CategoryBanner
        bannerMessage={true}
        categoryImage={categoryImage}
        MarketCategoryType="AGR10"
        quote="quote"
      />
      {/* Footer  Component */}
      <FooterComponent />
    </>
  );
};

export default ExploreCareProducts;
